import { Injectable } from '@angular/core';
import { Model_ResponseWorkflow, QueryParams_ResponseWorkflow, StartupInfos_HistoriqueResponseWorkflows, PaginatedResults, CODE_WORKFLOW_COMPONENT } from 'src/app/app.models';
import { UnitOfWorkOfflineDao } from '../../daos/unitofwork-offline.dao';

@Injectable()
export abstract class ResponseWorkflowService {
    public abstract doGetHistoriqueStartupInfosAction(): Promise<StartupInfos_HistoriqueResponseWorkflows>;
    public abstract doGetResponsesWorkflowAction(_queryParams: QueryParams_ResponseWorkflow): Promise<PaginatedResults<Model_ResponseWorkflow>>;
    public abstract doSaveResponseWorkflowAction(_responseWorkflow: Model_ResponseWorkflow): Promise<Model_ResponseWorkflow>;
    public abstract doGetResponseWorkflowByIDAction(ID: any): Promise<Model_ResponseWorkflow>;
    public abstract doCancelResponseWorkflow(ID: any): Promise<Model_ResponseWorkflow>;
    public abstract doReadResponseWorkflowFile(componentCode: CODE_WORKFLOW_COMPONENT, filename: string): Promise<string>;
    public abstract doDownloadResponseWorkflowFile(componentCode: CODE_WORKFLOW_COMPONENT, filename: string): Promise<void>;

    constructor(
        protected _unitOfWork: UnitOfWorkOfflineDao
    ) {}

    async doGetNotSyncedResponsesWorkflow() {
        const localResponses = await this._unitOfWork.responseWorkflowDao.doGetResponsesAction();
        return localResponses.filter(r => r.SYNCED !== undefined && r.SYNCED === false);
    }
}